package gr.tech.meetinggenie.models.meeting

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class DealStage {
    @SerialName("discovery")   DISCOVERY,
    @SerialName("proposal")    PROPOSAL,
    @SerialName("negotiation") NEGOTIATION,
    @SerialName("call_set")    CALL_SET,
    @SerialName("other")       OTHER;

    val label get() = when (this) {
        DISCOVERY   -> "Discovery/intake"
        PROPOSAL    -> "Proposal"
        NEGOTIATION -> "Negotiation"
        CALL_SET    -> "Call set"
        OTHER       -> "Other"
    }
}

@Serializable
enum class ProjectNeed {
    @SerialName("help")             HELP,
    @SerialName("product_support")  PRODUCT_SUPPORT,
    @SerialName("unresponsive_dm")  UNRESPONSIVE_DM,
    @SerialName("capital")          CAPITAL,
    @SerialName("nothing")          NOTHING;

    val label get() = when (this) {
        HELP            -> "Help"
        PRODUCT_SUPPORT -> "Product support"
        UNRESPONSIVE_DM -> "Decision maker unresponsive"
        CAPITAL         -> "Capital"
        NOTHING         -> "Nothing right now"
    }
}

@Serializable
data class ActiveProjectDTO(
    var projectName: String = "",
    var dealStage: DealStage? = null,
    var biggestBlocker: String = "",
    var needs: List<ProjectNeed> = listOf()
)
